module.exports = __webpack_public_path__ + "static/media/02_3.5957cd3f.png";